export enum Roles {
  SuperAdmin = 1,
  Admin = 2,
  Partner = 3,
  Manager = 4,
  Cashier = 5
}